import { render, staticRenderFns } from "./ImageSize.vue?vue&type=template&id=1b4ebe87&scoped=true"
import script from "./ImageSize.vue?vue&type=script&lang=js"
export * from "./ImageSize.vue?vue&type=script&lang=js"
import style0 from "./ImageSize.vue?vue&type=style&index=0&id=1b4ebe87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ebe87",
  null
  
)

export default component.exports